export default function PageHeader({ title, subtitle, actions, testId = "page-header" }) {
  return (
    <div className="flex items-start justify-between mb-6" data-testid={testId}>
      <div>
        <h1 className="text-2xl font-semibold text-brand-navy" style={{ color: "var(--brand-navy)" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-brand-muted mt-1" style={{ color: "var(--brand-muted)" }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
